export enum Locale {
  et = 'et',
  en = 'en',
  ru = 'ru',
}
